var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden sm:block"},[_c('div',{staticClass:"py-8"},[_c('div',{staticClass:"border-t border-gray-200"})])])
}]

export { render, staticRenderFns }